import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Receipt.css';
import moment from 'moment';

export default class ValidationReceipt extends Component { 

  constructor(props){
    super(props);
    this.state = {data: {}};
  }

  componentDidMount(){
    this.baseUrl = process.env.REACT_APP_API_URL;
    this.getBookingDetails();
  }
  
  getBookingDetails(){
    const urlParams = new URLSearchParams(window.location.search);
    let bookingId = urlParams.get('id');
    if(!bookingId){
      toast.dismiss();
      toast.error("Params missing in URL!");
      return;
    }
    this.setState({loading: true})
    fetch(`${this.baseUrl}/parking/valet/booking/validation-info/hash?hash=${bookingId}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
            this.setState({
                data: resp.data
            })
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            this.setState({loading: false});
            toast.dismiss();
            toast.error(errMsg);
          }
        })
        .catch((error) => {
          this.setState({loading: false});
          toast.dismiss();
          toast.error('Something went wrong');
        });
  }

  getDate(dateString){
    if(!dateString || !dateString.includes('T')) return;
    let indexOfT = dateString.indexOf("T", dateString.indexOf("T"));
    let dataBeforeT = "";
    if (indexOfT !== -1) {
      dataBeforeT = dateString.substring(0, indexOfT).trim();
    }
    if(dataBeforeT) dataBeforeT = moment(dataBeforeT, "YYYY-MM-DD").format("MMM DD, YYYY");
    return dataBeforeT;
  }


  render() {
    const data = this.state.data;
    if(!data) return (<>
      <div className='receipt-loading'>Getting your receipt...</div>
      <ToastContainer autoClose={2000} closeButton={true} style={{fontSize: 14}}/>
    </>)
    return (
      <div className="receipt">
        <div className='top-wrap'>
            <div className='top-section'>
                <div class="top-logo get-flex">
                    <div class="get-col column">
                        <img style={{height: '53px', position: 'relative', top: '-15px', left: '-12px'}} src="https://portal.parkquility.com/public/pq_logo.png" />
                    </div>
                    <div class="get-col column">
                        <div className='text-right'>Total: ${data.transaction_amount ? (data.transaction_amount/100).toFixed(2) : '0.00'}</div>
                        <div className='text-right'>{data.transaction_date}</div>
                    </div>
                </div>
            </div>    
            <h4>Your Payment is Successful</h4>
        </div>
        <div className='get-flex mid-section'>
            <div className='get-col'>Total</div>
            <div className='get-col text-right'>${data.transaction_amount ? (data.transaction_amount/100).toFixed(2) : '0.00'}</div>
        </div>
        <div className='booking-info'>
            <div className='get-flex'>
                <div className='get-col'>No. of Validations</div>
                <div className='get-col text-right'>{data.no_of_coupons || '0'}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>Validation Cost</div>
                <div className='get-col text-right'>${data.coupon_cost ? (data.coupon_cost/100).toFixed(2) : '0.00'}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>Discount Amount</div>
                <div className='get-col text-right'>${data.discount_amount ? (data.discount_amount/100).toFixed(2) : '0.00'}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>Total Convenience Fee</div>
                <div className='get-col text-right'>${data.total_conv_fees ? (data.total_conv_fees/100).toFixed(2) : '0.00'}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>Transaction Amount</div>
                <div className='get-col text-right'>${data.transaction_amount ? (data.transaction_amount/100).toFixed(2) : '0.00'}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>Transaction Status</div>
                <div style={{textTransform: 'capitalize'}} className='get-col text-right'>{data.transaction_status}</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>Transaction ID</div>
                <div style={{wordBreak: 'break-all'}} className='get-col text-right'>{data.transaction_id}</div>
            </div>
            <div style={{borderTop: '1px solid #c7c6c6', paddingTop: '10px'}} className='get-flex'>
                <div style={{fontWeight: 'bold'}} className='get-col'>Card on File</div>
            </div>
            <div className='get-flex'>
                <div className='get-col'>{data.card_type} - {data.last_four_digits}</div>
                <div className='get-col text-right'>${data.transaction_amount ? (data.transaction_amount/100).toFixed(2) : '0.00'}</div>
            </div>
        </div>
        <ToastContainer autoClose={2000} closeButton={true} style={{fontSize: 14}}/>
      </div>
    )
  }
}